<form
  [formGroup]="jobRequestForm"
  class="job-request-edit-form">
  <div class="card-box">
    <h1 class="card-title">
      {{ ("jobRequest" | i18n) || "Dienstanfrage" | titlecase }}
    </h1>
    <mat-form-field
      *ngIf="!(hideJobType$ | async)"
      class="light-form-field"
      data-cy="job-request-job-type-select">
      <mat-label>{{ ("jobType" | i18n) || "Jobtype" | titlecase }}</mat-label>
      <mat-select
        formControlName="jobType"
        (selectionChange)="jobTypeSelected()"
        [attr.data-cy]="'job-type-value-' + jobRequestForm.value.jobType">
        <ng-container *ngIf="!shiftJobTypes?.length">
          <mat-option
            *ngFor="let jobType of jobTypeEnum | enumToArray"
            [value]="jobTypeEnum[jobType]"
            [attr.data-cy]="'job-type-select-option-' + jobTypeEnum[jobType]">
            {{ ("jobTypeEnum." + jobTypeEnum[jobType] | i18n) || jobType }}
          </mat-option>
        </ng-container>
        <ng-container *ngIf="shiftJobTypes?.length">
          <mat-option
            *ngFor="let jobType of shiftJobTypes"
            [value]="jobType"
            [attr.data-cy]="'job-type-select-option-' + jobType">
            {{ ("jobTypeEnum." + jobType | i18n) || jobType }}
          </mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>

    <app-department-select
      class="light-form-field"
      (departmentSelectionChanged)="selectDepartment($event)"
      [selectedDepartmentId]="departmentIdControl?.value"
      [valid]="!!departmentIdControl?.value"
      [autoSelectOnlyDepartment]="true"
      [required]="true">
    </app-department-select>

    <app-date-ranges-input
      [showValidation]="false"
      [dateRanges]="dateRangesControl?.value"
      (dateRangesChanged)="dateRangesChanged($event)">
    </app-date-ranges-input>

    <mat-form-field
      *ngIf="enableCaseNumberInJobRequests$ | async"
      class="light-form-field">
      <mat-label>{{
        ("caseNumber" | i18n) || "Fallnummer" | titlecase
      }}</mat-label>
      <input
        matInput
        formControlName="caseNumber"
        [placeholder]="('caseNumber' | i18n) || 'Fallnummer' | titlecase"
        data-cy="job-request-case-number-input" />
    </mat-form-field>
    <mat-form-field
      *ngIf="!(hideDescription$ | async)"
      class="light-form-field">
      <mat-label>{{
        ("description" | i18n) || "description" | titlecase
      }}</mat-label>
      <textarea
        matInput
        formControlName="description"
        [placeholder]="('description' | i18n) || 'description' | titlecase"
        rows="7"
        data-cy="description-input">
      </textarea>
    </mat-form-field>
  </div>

  <div class="card-box">
    <h1 class="card-title">
      {{
        ("internalInformation" | i18n) || "Interne Informationen" | titlecase
      }}
    </h1>
    <div class="row">
      <div class="col">
        <app-demand-reason-select
          [formControl]="demandReasonControl"
          [required]="true"
          [lightFormField]="true"
          [showDescription]="true"
          [descriptionControl]="demandReasonDescriptionControl"
          data-cy="job-request-reason-select">
        </app-demand-reason-select>
      </div>
    </div>

    <div
      class="row"
      *ngIf="
        (customer$ | async)?.enableInternalDescription &&
        !(customer$ | async)?.hiddenFields?.jobDescription
      ">
      <div class="col">
        <mat-form-field class="light-form-field">
          <mat-label>{{
            ("internalDescription" | i18n) || "interne beschreibung" | titlecase
          }}</mat-label>
          <textarea
            matInput
            [placeholder]="
              ('internalDescription' | i18n) || 'interne beschreibung'
                | titlecase
            "
            formControlName="internalDescription"
            name="internalDescription"
            rows="3"
            data-cy="internal-description-input">
          </textarea>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="card-box">
    <h1 class="card-title">
      {{ ("criteria" | i18n) || "Kriterien" | titlecase }}
    </h1>
    <div class="row">
      <div class="col-md-6">
        <app-sex-select
          class="light-form-field"
          *ngIf="!(hideSex$ | async)"
          [formControl]="sexControl"
          data-cy="job-sex-select">
        </app-sex-select>
      </div>
      <div class="col-md-6"></div>
      <div class="col-md-6">
        <app-certificate-select
          class="light-form-field"
          *ngIf="!(hideCertificates$ | async)"
          [selectedMappedCertificates]="certificatesControl?.value"
          [required]="!!(certificatesRequired$ | async)"
          (selectionChanged)="certificatesSelected($event)">
        </app-certificate-select>
      </div>
      <div
        class="col-md-6"
        *ngIf="!!(specialitiesVisible$ | async)">
        <app-speciality-select
          class="light-form-field"
          *ngIf="!(hideCertificates$ | async)"
          [selectedMappedSpecialities]="specialitiesControl?.value"
          (selectionChanged)="specialitiesSelected($event)">
        </app-speciality-select>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <app-pooler-type-multi-select
          class="light-form-field"
          *ngIf="!(hidePoolerTypes$ | async)"
          [selectedPoolerTypeIds]="poolerTypesControl.value"
          (selectionChanged)="poolerTypesSelected($event)"
          data-cy="pooler-type-select">
        </app-pooler-type-multi-select>
      </div>
    </div>
  </div>

  <ng-container *ngIf="jobRequestCustomCriteria$ | async as customCriteriaList">
    <div
      *ngIf="customCriteriaList.length"
      class="card-box">
      <h1 class="card-title">
        {{ "customCriteria" | i18n | titlecase }}
      </h1>
      <div
        class="row mb-2"
        *ngFor="
          let customCriteria of customCriteriaList;
          trackBy: trackByCustomCriteriaId
        ">
        <div class="col">
          <ng-container
            *ngIf="customCriteria.type === customCriteriaTypeEnum.TOGGLE">
            <mat-slide-toggle
              class="custom-criteria-job-toggle"
              [(ngModel)]="jobToggleCriterion(customCriteria.id).value"
              (ngModelChange)="jobCustomCriteriaChanged()"
              [ngModelOptions]="{ standalone: true }"
              [name]="'job-request-custom-crit-toggle-' + customCriteria.id"
              [attr.data-cy]="
                'job-request-custom-crit-toggle-' + customCriteria.id
              ">
              {{ customCriteria.displayName }}
            </mat-slide-toggle>
          </ng-container>
          <mat-form-field
            *ngIf="customCriteria.type === customCriteriaTypeEnum.SELECT"
            class="light-form-field w-100">
            <mat-label>{{ customCriteria.displayName | titlecase }}</mat-label>
            <mat-select
              *ngIf="customCriteria.multiple"
              multiple
              [compareWith]="compareCustomCriteriaOption"
              [(ngModel)]="jobSelectCriterion(customCriteria.id).values"
              (ngModelChange)="jobCustomCriteriaChanged()"
              [ngModelOptions]="{ standalone: true }"
              [name]="
                'job-request-custom-crit-select-multi-' + customCriteria.id
              "
              [attr.data-cy]="
                'job-request-custom-crit-select-multi-' + customCriteria.id
              ">
              <mat-option
                *ngFor="let option of customCriteria.options"
                [value]="option">
                {{ option.displayName }}
              </mat-option>
            </mat-select>
            <mat-select
              *ngIf="!customCriteria.multiple"
              [compareWith]="compareCustomCriteriaOption"
              [ngModel]="
                getJobSingleSelectValue(
                  $any(
                    customerInternalInformation.customCriteria![
                      customCriteria.id
                    ]
                  )
                )
              "
              (ngModelChange)="
                setJobSingleSelectValue(
                  $any(
                    customerInternalInformation.customCriteria![
                      customCriteria.id
                    ]
                  ),
                  $event
                );
                jobCustomCriteriaChanged()
              "
              [ngModelOptions]="{ standalone: true }"
              [name]="
                'job-request-custom-crit-select-single-' + customCriteria.id
              "
              [attr.data-cy]="
                'job-request-custom-crit-select-single-' + customCriteria.id
              ">
              <mat-option
                *ngFor="let option of customCriteria.options"
                [value]="option">
                {{ option.displayName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  </ng-container>

  <div
    class="card-box"
    *ngIf="multiDays.length">
    <h1 class="card-title">
      {{ ("summary" | i18n) || "Zusammenfassung" | titlecase }}
    </h1>
    <div class="summary-content">
      <div
        *ngFor="let day of multiDays"
        class="multiDay-row"
        [attr.data-cy]="'multi-day-item-date-' + day.dateString"
        [class.day-disabled]="!day.enabled">
        <div class="multiDay-toggle">
          <button
            type="button"
            class="outline-pill-button icon-only"
            (click)="toggleDayEnabled(day); $event.stopPropagation()">
            <mat-icon [svgIcon]="day.enabled ? 'minus' : 'plus'"></mat-icon>
          </button>
        </div>
        <div class="multiDay-date">
          {{ day.date | date: "EEEEEE, dd.MM.yyyy" }}
        </div>
        <app-editable-shift-tags
          [shifts]="day.shifts"
          [jobType]="day.jobType"
          [isDisabled]="false"
          [availableShifts]="day.availableDepartmentShifts"
          (shiftsModified)="
            editMultiDayShifts(day, $event)
          "></app-editable-shift-tags>
      </div>
    </div>
  </div>
</form>

<div class="flex-grow-1"></div>
<div
  class="floating-actions-bar job-request-actions-bar"
  *ngIf="!isSubmitting">
  <button
    class="secondary-pill-button icon-left big-fab"
    type="button"
    data-cy="cancel-button"
    (click)="historyBack()">
    <mat-icon svgIcon="arrow-left"></mat-icon>
    <span class="mat-fab__label">
      {{ ("back" | i18n) || "zurück" | titlecase }}</span
    >
  </button>
  <button
    class="primary-pill-button icon-left big-fab"
    type="button"
    data-cy="submit-job-requests-button"
    (click)="createJobRequests()">
    <mat-icon svgIcon="send"></mat-icon>
    <ng-container *ngIf="multiDays.length === 1; else sendMultipleRequests">
      {{ ("request" | i18n) || "Anfragen" | titlecase }}
    </ng-container>
    <ng-template #sendMultipleRequests>
      {{
        "sendXRequests"
          | i18n: { count: multiDays.length.toString() }
          | titlecase
      }}
    </ng-template>
  </button>
</div>
